import * as fetch from 'isomorphic-fetch';

interface IOptions {
  url: string;
  method?: string;
  data?: any;
  headers?: any;
  mode?: string;
  shopDomain?: string;
  noChecklogin?: boolean;
};

const shopInfoRequests: {[key: string]: Promise<any>} = {};

const isShopInfoRequest = (options: IOptions): boolean =>
  options.url.indexOf('wshop/shop/shop-info') > -1;

const getShopInfoCacheKey = (options: IOptions): string => {
  const data = options.data || {};
  const normalizedData: {[key: string]: any} = {};
  Object.keys(data).sort().forEach(key => {
    normalizedData[key] = data[key];
  });

  return [
    options.url,
    JSON.stringify(normalizedData)
  ].join(':');
};

// Callers occasionally modify response fields before putting them into state.
// Each caller therefore receives its own object even though the HTTP request is shared.
const cloneResponse = (response: any): any => {
  if (typeof response === 'undefined') {
    return response;
  }
  return JSON.parse(JSON.stringify(response));
};

const executeRequest = async (options: IOptions) => {
  let dataTemp = '';
  if(options.method && typeof options.method === 'string' && options.method.toLowerCase() === 'post') {
    if(typeof options.data === 'string') {
      dataTemp = options.data;
    } else if(options.data) {
      dataTemp = encodeFormData(options.data);
    }
    try {
      const r: any = await fetch(options.url, {
        body: dataTemp,
        credentials: 'include',
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded;charset=utf-8',
          ...(options.headers || {})
        },
        method: 'POST',
        mode: 'cors'
      }).then(response => response.json());

      // 如果是英文版，并且没有开通英文店铺，跳转回中文首页
      checkAndJumpToMain(options, r)

      // 如果没有登录
      if(!options.noChecklogin && (r.code === 100 || r.error_code === 100 || r.error_code === 57000)) {
        const loginComponent: any = (window as any).login;
        if(loginComponent) {
          loginComponent.show();
        }
        return {};
      }
      // 如果没有店铺id
      else if(r.error_code === 58000) {
        window.location.href = '/m/404/';
      } else if (r.error_code === 59000) {
        window.location.href = '/m/404/?c=1'
      } 
      else {
        return r;
      }
    } catch(err) {
      return {};
    }

  } else {
    if(options.data) {
      dataTemp = (options.url.indexOf('?') === -1 ? '?' : '&') + encodeFormData(options.data);
    }
    try {
      const r: any = await fetch(options.url + dataTemp, {
        credentials: "include",
        headers: options.headers || {},
        mode: 'cors'
      }).then(response => response.json()); 
      // 如果是英文版，并且没有开通英文店铺，跳转回中文首页
      checkAndJumpToMain(options, r)
      if(!options.noChecklogin && (r.code === 100 || r.error_code === 100 || r.error_code === 57000)) {
        const loginComponent: any = (window as any).login;
        if(loginComponent) {
          loginComponent.show();
        }
        return {};
      } else {
        return r;
      }
    } catch(err) {
      return {};
    }
  }
}

function encodeFormData(data: any) {
  return Object.keys(data).map(item => {
    const value = data[item] === null || typeof data[item] === 'undefined' ? '' : data[item];
    return `${encodeURIComponent(item)}=${encodeURIComponent(String(value))}`;
  }).join('&');
}

const request = async (options: IOptions) => {
  if (!isShopInfoRequest(options)) {
    return executeRequest(options);
  }

  const cacheKey = getShopInfoCacheKey(options);
  if (!shopInfoRequests[cacheKey]) {
    shopInfoRequests[cacheKey] = executeRequest(options).then(response => {
      // Do not permanently cache failed/login-expired responses. Concurrent
      // callers are still deduplicated, while a later action can retry.
      if (!response || response.error_code !== 0) {
        delete shopInfoRequests[cacheKey];
      }
      return response;
    }, error => {
      delete shopInfoRequests[cacheKey];
      throw error;
    });
  }

  return shopInfoRequests[cacheKey].then(cloneResponse);
};

function checkAndJumpToMain(option: IOptions, responseData: any) {
  if (option.url.indexOf('wshop/shop/shop-info') > -1
    && option.data
    && option.data.lanType === 1
    && responseData.data
    && responseData.data[0]
    && responseData.data[0].is_cross_border !== '2') {
    window.location.href = '/m/';
  }
}

export default request;



// WEBPACK FOOTER //
// ./src/utils/request.ts